import { Record } from '@gonfalon/immutable-shim/immutableShim';

import type { PubNubProps } from '#utils/environments/types';

export class PubNub extends Record<PubNubProps>({
  channel: '',
  cipherKey: '',
  pubnubUuid: '',
}) {}
